import Vue from 'vue';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import store from '../../store';

export function modifyChat(chat, excludeRole) {
  chat = cloneDeep(chat);
  // console.dir(chat);
  chat.isModified = true;
  chat.members = chat.users.filter(user => user.id !== store.state.loggedAccount.account.id && (!excludeRole || user.role !== excludeRole));

  // Set role name for i18n
  chat.members.forEach(user => {
    if (user.role === 'PROVIDER') user.roleName = 'constants.userRoles.provider';
    else if (user.role === 'PATIENT') user.roleName = 'constants.userRoles.patient';
    else if (user.role === 'CLINIC_ADMIN') user.roleName = 'constants.userRoles.ca';
  });

  // Chek members length for set chat picture
  if (chat.members.length === 1) chat.picture = chat.members[0].profilePicture;

  if (chat.lastMessageCreatedAt) chat.actionTime = moment(chat.lastMessageCreatedAt).format('hh:mm');
  else {
    const createdAt = moment.utc(chat.createdAt).startOf('day');
    const today = moment.utc().startOf('day');
    const yesterday = today.subtract({ days: 1 });

    if (createdAt === today) chat.actionTime = 'Today';
    else if (createdAt === yesterday) chat.actionTime = 'Yesterday';
    else chat.actionTime = moment(chat.createdAt).format('dddd');
  }

  return chat;
}

function makeChatFromAccount(account) {
  const chat = { ...account };
  chat.isNew = true;
  chat.users = [account, store.state.loggedAccount.account];
  return modifyChat(chat);
}

// Get chat in component from query id
export async function getChat(id) {
  const chats = store.state.messenger.chats;
  const activeChat = chats.find(chat => chat.id === +id);

  if (activeChat) return { chat: activeChat, showAccounts: false };

  let activeAccount = await Vue.prototype.$api.accounts.getAccount(id);
  activeAccount = activeAccount.data.payload;
  if (activeAccount) return await checkChatExists(activeAccount);

  throw 'Not found';
}

export function checkChatExists(account) {
  return Vue.prototype.$api.messages.getChatExists(account.id).then(({ data }) => {
    const [chat] = data.payload;
    const chats = store.state.messenger.chats;

    let savedChat = chats.find(c => c.id === chat.id);
    if (!savedChat) {
      savedChat = modifyChat(chat);
      store.commit('messenger/addChat', savedChat);
    }

    return { chat: savedChat, showAccounts: false };
  }).catch(() => ({
    chat: makeChatFromAccount(account),
    showAccounts: { show: true, role: account.role, clinic: account.clinicIds[0] } }));
}
